<template>
  <!-- <svg viewBox="0 0 36 36" class="circular-chart green">
    <path
      class="circle-bg"
      d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
    />
    <path
      class="circle"
      :stroke-dasharray="scorePercent"
      d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
    />
    <text x="18" y="22.35" class="percentage">{{ score }}/10000</text>
    <text x="18" y="16.35" class="percentage">امتیاز :</text>
  </svg> -->
  <div class="score-header">
    <h2>
      <img src="/img/csoin21.png" class="score-coin" />
      امتیاز شما :
      <span>{{ getScore }} </span>
    </h2>
  </div>
</template>


<script>
export default {
  name: "ScoreChart",
  components: {},
  data: function () {
    return {
      scorePercent: "",
      score: 0,
    };
  },
  created() {
    this.setData();
  },
  computed: {
    getScore() {
      return this.$store.getters.GetCustomerClubData.score;
    },
  },
  methods: {
    async setData() {
      this.score = this.$store.getters.GetCustomerClubData.score;
      this.card = this.$store.getters.GetCustomerClubData.segment;
      this.segment = this.$store.getters.GetCustomerClubData.segment;

      this.scorePercent = (this.score / 10000) * 100;
      this.scorePercent = this.scorePercent + ",100";
      return this.scorePercent, this.card;
    },
  },
  // destroyed() {
  //   this.$store.commit("SetUserScore", "");
  //   this.$store.commit("SetUserSegment", "");
  // },
};
</script>
<style lang="scss">
.score-box {
  background: #ffffff;
  padding: 60px 20px 50px;
  width: 300px;
  height: 184px;
  margin: 30px auto;
  position: relative;
  border-radius: 25px;
  border-bottom: 1px solid #c5d9d9;
  -webkit-filter: drop-shadow(2px 1px 2px rgba(0, 0, 0, 0.3));
  .ribbon-img {
    top: -28px;
    right: 40px;
    position: absolute;
    width: 210px;
  }
  .user-tropy-small {
    width: 60px;
  }
  h2 {
    color: #2561a4;
    span {
      display: block;
      font-size: 21px;
      color: #172b4d;
      margin-top: 20px;
    }
  }
}

.circular-chart {
  width: 120px;
  &.green {
    .circle {
      stroke: #0472a5;
    }
  }
}
.score-header span {
  color: #a05d1b;
}
.score-header .score-coin {
  width: 150px;
  margin: 15px;
}
.circle-bg {
  fill: none;
  stroke: rgba(182, 185, 175, 0.568);
  stroke-width: 3.8;
}
.circle {
  fill: none;
  stroke-width: 3.8;
  /* stroke-linecap: round; */
  animation: progress 1s ease-out forwards;
}
.percentage {
  fill: rgb(32, 30, 30);
  font-size: 4px;
  text-anchor: middle;
}
@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}
</style>
